@if (!topLevel()) {
  <div
    data-testid="component-modal-backdrop"
    class="modal-backdrop bg-gray-100"
    [ngClass]="{ show: modal?.open }"
    (click)="attemptToCloseByClickingOutside()"
  ></div>
}

<dialog
  data-testid="component-modal"
  #modal
  [ngClass]="classes()"
  [attr.aria-hidden]="!modal?.open"
  [attr.aria-modal]="'true'"
  [attr.aria-labelledby]="headerId"
  [attr.aria-describedby]="bodyId"
>
  <div class="modal-header flex">
    <h1 [id]="headerId" class="flex-1 text-2xl font-bold tracking-tight text-center whitespace-nowrap overflow-hidden text-ellipsis">
      <ng-content select="[header]"></ng-content>
    </h1>

    <app-pan-button
      #closeButton
      data-testid="pan-modal-close-button"
      icon="close"
      fill="clear"
      ariaLabel="Close modal"
      panModalClose
    ></app-pan-button>
  </div>

  <div [id]="bodyId" class="modal-body" [class.should-scroll]="shouldBodyScroll()" [style.max-height]="maxBodyHeight() ?? null">
    <ng-content select="[body]"></ng-content>
  </div>

  <div class="modal-footer flex gap-2 justify-end">
    <ng-content select="[footer]"></ng-content>
  </div>
</dialog>
